import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  StructureGrayButton,
  StructureNavigation
} from '../../../MyTeamBackofficeStyled';
import { Position, StructureType } from '../../../myTeamBackOffice.constants';
import AddNewMemberModal from '../../../common/AddNewMemberModal/AddNewMemberModal';
import {
  BackOnTopButton,
  DefaultPlacementButton,
  GoBottomButton,
  GoLeftDownArrowButton,
  GoRightDownArrowButton,
  GoUpArrowButton
} from '../../common';

import { motion } from 'framer-motion';
import { useAppSelector } from '../../../../../app/hooks';

const StructureNav = () => {
  const { t } = useTranslation('myTeam');
  const { isCanadaRestrictedUser, user } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <motion.div>
      <StructureNavigation>
        <GoUpArrowButton />
        <GoLeftDownArrowButton />
        <BackOnTopButton />
        <GoBottomButton
          position={Position.L}
          label={t('go_bottom_left')}
          isDisabled={false}
          structureType={StructureType.TEAM}
        />
        {!isCanadaRestrictedUser && (
          <StructureGrayButton
            orangeGradient
            onClick={() => {
              window.open(`/email-address/${user.id}`, '_blank');
            }}>
            {t('add_new_member')}
          </StructureGrayButton>
        )}

        <GoBottomButton
          position={Position.R}
          label={t('go_bottom_right')}
          isDisabled={false}
          structureType={StructureType.TEAM}
        />
        {!isCanadaRestrictedUser && <DefaultPlacementButton />}

        <GoUpArrowButton />
        <GoRightDownArrowButton />
      </StructureNavigation>
    </motion.div>
  );
};

export default StructureNav;
